export enum DuplicateSearchType {
    Address,
    FaxNumber,
    Name,
    LicenceNumber,
    Pharmacist
}
